// src/firebase/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc } from 'firebase/firestore';

// Your Firebase configuration (replace with actual config)
const firebaseConfig = {
    apiKey: "AIzaSyBHn0xC77eFYeRL-Jb_2yoYQNIgbqe280s",
    authDomain: "brand-bounce.firebaseapp.com",
    projectId: "brand-bounce",
    storageBucket: "brand-bounce.firebasestorage.app",
    messagingSenderId: "890467865700",
    appId: "1:890467865700:web:228ab0a763225c21307b71",
    measurementId: "G-SC75KB2TVN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db, collection, addDoc }; // Export Firestore methods
